import _slicedToArray from "/home/kbus/kbus-website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useReducer } from 'react';
import highlightReducer from './highlightReducer';
export default function useHighlight(defaultHighlighted, options, onSelect, ref) {
  var _useReducer = useReducer(highlightReducer, defaultHighlighted),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      highlighted = _useReducer2[0],
      dispatchHighlighted = _useReducer2[1];

  var onKeyDown = useCallback(function (e) {
    var key = e.key;

    if (['ArrowDown', 'ArrowUp'].includes(key)) {
      e.preventDefault();
      dispatchHighlighted({
        key: key,
        options: options
      });
    }
  }, [options]);
  var onKeyPress = useCallback(function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var selected = options[highlighted];

      if (selected) {
        onSelect(selected.value);
      }
    }
  }, [options, highlighted, onSelect]);
  var onKeyUp = useCallback(function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      ref.current.blur();
    }
  }, [ref]);
  return [highlighted, {
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }];
}